import { render, staticRenderFns } from "./EmailAdd.vue?vue&type=template&id=60bc8b41"
import script from "./EmailAdd.vue?vue&type=script&lang=js"
export * from "./EmailAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports